<template>
  <div
    class="table-header-item"
    data-testid="table-header-item"
  >
    <span
      class="table-header-item__text"
      v-text="text"
    />

    <v-tooltip
      v-if="tooltipText"
      top
      content-class="table-header-item__tooltip"
    >
      <template v-slot:activator="{ on }">
        <span
          class="table-header-item__icon-questions"
          :aria-label="tooltipText"
          v-on="on"
          @mouseover="$emit('show-tooltip', text)"
        >
          <DsIcon
            name="questions"
            size="small"
          />
        </span>
      </template>

      <span
        data-testid="tooltip-text"
        v-text="tooltipText"
      />
    </v-tooltip>
  </div>
</template>

<script>
import { DsIcon } from '@ds/icons';

export default {
  name: 'TableHeaderItem',
  components: {
    DsIcon,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    tooltipText: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-header-item {
  display: inline;

  &__text {
    font-size: var(--ds-font-size--xs);
    font-weight: var(--ds-font-weight-semibold);
  }

  &__tooltip {
    max-width: 245px;
    font-size: var(--ds-font-size-xs);
    line-height: var(--ds-font-size-baseline);
    background-color: var(--ds-color-reverse);
    padding: var(--ds-spacing-stack-nano);
    opacity: 1;

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #1f1f1f transparent transparent transparent;
    }
  }

  & > &__icon-questions {
    margin-left: var(--ds-spacing-stack-nano);

    i {
      font-size: 10.67px;
    }
  }
}
</style>
